import { Pencil } from 'lucide-react'
import * as React from 'react'

import { Button } from '@/components/ui/button'

interface DataRowProps {
  label: string
  value: string | React.ReactNode
  onEdit?: () => void
  showEditButton?: boolean
}

export const DataRow = ({ label, value, onEdit, showEditButton = false }: DataRowProps) => (
  <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-3 sm:items-center sm:gap-2">
    <span className="type-label text-muted-foreground">{label}</span>
    <div className="flex items-center justify-between text-sm text-foreground sm:col-span-2">
      <span className="min-w-0">{value}</span>
      {showEditButton && onEdit && (
        <Button variant="ghost" size="sm" onClick={onEdit} className="ml-auto">
          <Pencil className="mr-1 h-3 w-3" />
          Edit
        </Button>
      )}
    </div>
  </div>
)
